const SkeletonGeneralSummaryCard = () => {
  return (
    <div className="animate-pulse overflow-hidden rounded-lg border border-[#EAECF0] bg-white px-3 py-6 text-center shadow-sm">
      <div className="flex items-center gap-3">
        <div className="flex h-8 w-8 items-center justify-center rounded-full bg-blue-50">
          <div className="h-5 w-5 rounded bg-gray-300"></div>
        </div>
        <div className="flex flex-col items-start text-left">
          <div className="mb-1 h-4 w-20 rounded bg-gray-300"></div>
          <div className="h-6 w-12 rounded bg-gray-300"></div>
        </div>
      </div>
    </div>
  );
};

const GeneralSummarySectionSkeleton = () => {
  return (
    <section
      aria-hidden="true"
      aria-busy="true"
      className="flex flex-col gap-4"
    >
      <div className="flex flex-col justify-between gap-4">
        <div className="flex items-center justify-between">
          <div className="h-6 w-48 rounded bg-gray-300"></div>
          <span className="flex items-center gap-1 rounded-lg border border-[#EAECF0] bg-[#F2F5F9] px-5 py-2">
            <div className="h-4 w-24 rounded bg-gray-300"></div>
          </span>
        </div>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          <SkeletonGeneralSummaryCard />
          <SkeletonGeneralSummaryCard />
          <SkeletonGeneralSummaryCard />
          <SkeletonGeneralSummaryCard />
        </div>
      </div>
    </section>
  );
};

export default GeneralSummarySectionSkeleton;
